import {
  ErrorResponseCodeType,
  EndPointsNames,
  ApiCredentialsType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/members';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH);
const API_CREDENTIALS_TYPE: ApiCredentialsType =
  'TOKEN_AUTH_USER_OR_CREDENTIALS';
const URL_POSTMAN =
  'https://smiles-sa.postman.co/workspace/1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/5caf9d23-01ea-4b50-8c93-f44afd1b0318?version=cf9ab4e6-e05e-4981-a12a-e91087babb43&tab=overview';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
  {
    code: '2',
    bussinessErrorVariant: 'passwordConfirmationFailed',
    message: 'Confirmação de senha difere de senha',
  },
  {
    code: '3',
    bussinessErrorVariant: 'userNotFound',
    message: 'Usuário não cadastrado',
  },
  {
    code: '4',
    bussinessErrorVariant: 'wrongData',
    message: 'Dados incorretos',
  },
  {
    code: '5',
    bussinessErrorVariant: 'cpfInvalid',
    message: 'CPF inválido.',
  },
  {
    code: '6',
    bussinessErrorVariant: 'wrongParams',
    message: 'Parâmetros ou dados incorretos',
  },
  {
    code: '7',
    bussinessErrorVariant: 'processFailure',
    message: 'Ocorreu um erro ao inserir cliente', // Campos obrigatórios em branco. [GENDER]
  },
  {
    code: '8',
    bussinessErrorVariant: 'ivaForArgentina',
    message: 'Iva obrigatório para Argentinos',
  },
  {
    code: '26',
    bussinessErrorVariant: 'emailAlreadyExists',
    message:
      'Identificamos que esse e-mail já está cadastrado. Tente outro, por favor.',
  },
  {
    code: '45',
    bussinessErrorVariant: 'passwordInvalid',
    message: 'Senha não pode ter dígitos sequenciais ou 4 dígitos repetidos',
  },
  {
    code: '69',
    bussinessErrorVariant: 'countryEmpry',
    message: 'O campo país do endereço deve ser preenchido',
  },
  {
    code: '203',
    bussinessErrorVariant: 'userPreIdentificated',
    message: 'Membro com status Pre Cadastro Banco.',
  },
  {
    code: '610',
    bussinessErrorVariant: 'unitFederationEmpty',
    message: 'O campo estado do endereço deve ser preenchido',
  },
  {
    code: '611',
    bussinessErrorVariant: 'phoneEmpty',
    message: 'O número do telefone celular deve conter no máximo 9 números.',
  },
  {
    code: '612',
    bussinessErrorVariant: 'phoneInvalid',
    message:
      'O número do telefone residencial/comercial deve conter no máximo 9 números.',
  },
  {
    code: '613',
    bussinessErrorVariant: 'DDDEmpty',
    message: 'O DDD do telefone residencial/comercial deve ser diferente de 0',
  },
  {
    code: '614',
    bussinessErrorVariant: 'DDIEmpty',
    message: 'O DDI do telefone residencial/comercial deve ser diferente de 0.',
  },
  {
    code: '615',
    bussinessErrorVariant: 'DDDEmpty',
    message: 'O DDD do telefone celular deve ser diferente de 0.',
  },
  {
    code: '616',
    bussinessErrorVariant: 'DDIEmpty',
    message: 'O DDI do telefone celular deve ser diferente de 0.',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
